import {KpiOption} from '@hconnect/common/types'

import {KpiNamesResponse} from '../types'

import {useSettingsQuery} from '@settings/modules/common/providers'

export const useKpiNames = (select: (arg: KpiNamesResponse) => KpiOption[]) =>
  useSettingsQuery('kpiNames', [], {select})
